/**
 * Downloads a blob as a file with the specified filename and MIME type
 * @param blobData - The blob data to download
 * @param filename - The name of the file to be downloaded
 * @param mimeType - The MIME type of the file (default: 'application/pdf')
 */
export const downloadBlob = (
    blobData: Blob | ArrayBuffer | any, 
    filename: string, 
    mimeType: string = 'application/pdf'
): void => {
    try {
        // Create blob from data if it's not already a blob
        const blob = blobData instanceof Blob 
            ? blobData 
            : new Blob([blobData], { type: mimeType });
        
        // Create download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        
        // Trigger download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Clean up
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Error downloading file:', error);
        throw new Error('Failed to download file');
    }
};